export const locale = {
    lang: 'es',
    data: {
        'YOUR_SESSION_EXPIRES_IN':'Su sesión expira en :'
    }
};